const CHANNEL_NAME = "webphone-call-channel";

/**
 * Publica vía BroadcastChannel un mensaje de "clic para llamar" que TelefonoSip.js
 * recibe y usa para iniciar la llamada automática.
 *
 * @param {string|number} numero  Número a marcar (string numérico, >3 dígitos).
 * @returns {boolean} true si se publicó, false si el número es inválido.
 */
export const publicarLlamadaWebphone = (numero) => {
  const numeroStr = String(numero || "").replace(/\s/g, "");
  if (!/^\d{4,}$/.test(numeroStr)) {
    console.warn("publicarLlamadaWebphone: número inválido", numero);
    return false;
  }

  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage({ event: "clic_call", numero: numeroStr });
  channel.close();
  return true;
};

export default publicarLlamadaWebphone;
